import * as api from '../../services/registration'

export const FETCH_REGISTRATIONS = 'FETCH_REGISTRATIONS';
export const FETCH_REGISTRATION = 'FETCH_REGISTRATION';


export const fetchRegistration = (id) => {
    return {
        type: FETCH_REGISTRATION,
        payload: {
            promise: api.findRegistration({id: id})
        }
    }
}


export const fetchRegistrations = (params, pagination, sort, extra) => {
    return {
        type: FETCH_REGISTRATIONS,
        payload: {
            promise: api.findRegistrations(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/registration.js